import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SuggestedPoint } from '../../../../../../interfaces/edit-route.response';
import { DefaultImgService } from 'src/app/services';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {
  // Input signals
  public indexCard = input.required<number>();
  public point = input.required<SuggestedPoint>();

  // Service injections
  private _defaultImgService = inject(DefaultImgService);
  
  /**
   * @param event
   * @returns 
   */
  public handleImgError(event: Event): void {
    const target = event.target as HTMLImageElement;
    if (target) {
      const defaultImg = this.getDefaultImgFileName(this.indexCard());
      if (!defaultImg) return;
      
      target.src = defaultImg;
    }
  }
  
  /**
   * @desciption Gets the default image file name for the card. In this case one point 
   * can have multiple categories so we pass the first one 
   * @param index
   * @returns 
   */
  public getDefaultImgFileName(index: number): string {
    return this._defaultImgService.getDefaultImgFileName(
      index,
      this.point().categoryList[0],
      this.point().type
    );
  }
}
